import React from 'react';
import { Heart, Shield, Leaf, BadgeCheck } from 'lucide-react';
export function TrustBar() {
  const items = [{
    icon: <Heart className="w-5 h-5" data-id="element-96" />,
    text: '80.000+ zufriedene Kunden'
  }, {
    icon: <BadgeCheck className="w-5 h-5" data-id="element-97" />,
    text: 'Von Tierärzten empfohlen'
  }, {
    icon: <Leaf className="w-5 h-5" data-id="element-98" />,
    text: '100% pflanzlich & natürlich'
  }, {
    icon: <Shield className="w-5 h-5" data-id="element-99" />,
    text: 'Geld-zurück-Garantie'
  }];
  return <div className="bg-stone-100 border-y border-stone-200 py-6 px-4" data-id="element-100">
      <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-101">
        {items.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-stone-600 font-sans text-sm font-medium" data-id="element-102">
            <span className="text-brand-green" data-id="element-103">{item.icon}</span>
            <span data-id="element-104">{item.text}</span>
          </div>)}
      </div>
    </div>;
}